/**
 * SearchForm custom element — search input UX only (reset + clear button).
 *
 * NOTE: this element used to intercept submit and append ` -tag:hidden` to
 * every query to hide products tagged 'hidden' from results. That was removed.
 * The storefront search does NOT honor the `-tag:` operator here: it read
 * `-tag:hidden` as literal negated text and silently dropped ~34% of valid
 * results (a search for "Blue" returned 191 instead of 288, and any nonsense
 * tag such as `-tag:banana` gave the same 191, proving it was parsed as text,
 * not a filter). No product is tagged 'hidden', so it hid nothing. Searches now
 * run on exactly what the user typed. If real search hiding is ever needed, use
 * a search app or Shopify's native search settings, not a `-tag:` operator.
 */

class SearchForm extends HTMLElement {
	constructor() {
		super();
		this.input = this.querySelector('input[type="search"]');

		if (this.input) {
			this.input.form.addEventListener("reset", this.onFormReset.bind(this));
			this.input.addEventListener(
				"input",
				debounce((event) => {
					this.onChange(event);
				}, 300).bind(this)
			);
		}

		if (
			this.input.parentElement.querySelector(".search__input--icon-clear") !=
			null
		) {
			let clearIcon = this.input.parentElement.querySelector(
				".search__input--icon-clear"
			);

			clearIcon.addEventListener("click", () => {
				this.input.form.reset();
				this.onFormReset();
			});
			clearIcon.addEventListener("keydown", (event) => {
				if (event.key === "Enter") {
					this.input.form.reset();
					this.onFormReset();
				}
			});
		}
	}

	shouldResetForm() {
		return !document.querySelector('[aria-selected="true"] a');
	}

	onFormReset(event) {
		if (event) {
			event.preventDefault();
		}
		if (this.shouldResetForm()) {
			this.input.value = "";
		}
	}
}

customElements.define("search-form", SearchForm);
